import { useNavigate } from "@tanstack/react-router";

import { useCreateFromSource } from "@/react/components/shared/Emails/useCreateFromSource";
import { broadcastPaths } from "@/react/helpers/urlHelpers/broadcastPaths";
import { useIsEmailHubStatusEnabled } from "@/react/hooks/useIsEmailHubStatus";

export const useConvertEventToBroadcast = () => {
  const navigate = useNavigate();
  const { mutate: convertFromSource, ...rest } = useCreateFromSource();
  const isEmailHubEnabled = useIsEmailHubStatusEnabled();

  const handleSendAnnouncement = ({
    eventId,
    onSuccess,
  }: {
    eventId: number;
    onSuccess?: () => void;
  }) => {
    if (!isEmailHubEnabled) {
      void navigate({ href: broadcastPaths.list() });
      onSuccess?.();
      return;
    }

    convertFromSource(
      {
        source_content_id: eventId,
        source_content_type: "Event",
      },
      {
        onSuccess: data => {
          onSuccess?.();
          void navigate({
            to: "/settings/emails/broadcast/$id/edit",
            params: { id: String(data.broadcast.id) },
          });
        },
      },
    );
  };

  return {
    onSendAnnouncement: handleSendAnnouncement,
    ...rest,
  };
};
